import { Box, Grow, Stack, Typography, useMediaQuery } from "@mui/material";
import React from "react";

import Header from "../Header";
import SlideTransition from "../SlideTransition";

import useContent from "../../hooks/useContent";
import useInView from "../../hooks/useInView";

import { styles } from "./style";

const Solution = () => {
  const content = useContent();
  const [setRef, visible] = useInView({
    threshold: 0.3,
  });
  const matches = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <Stack ref={setRef} sx={styles.root}>
      <Stack spacing={0} sx={styles.body}>
        <Stack
          alignItems={"center"}
          spacing={24}
          sx={{ height: "100%", width: { xs: "100%", md: "30%" } }}
        >
          <SlideTransition appear={visible} timeout={800}>
            <Stack spacing={3}>
              <Header
                // color={"white"}
                center={matches ? true : true}
                data={content.solution}
                decorationPos={"bottom"}
                // style={{ color: theme.palette.grays["white"] }}
              />

              <Typography sx={styles.content}>
                {content.solution.body}
              </Typography>
            </Stack>
          </SlideTransition>
        </Stack>
      </Stack>

      <Grow in={visible} timeout={1200}>
        <img
          alt={content.solution.header}
          src={content.solution.image}
          style={{
            borderRadius: 18,
            overflow: "hidden",
            width: matches ? "90%" : "60%",
            height: "auto",
            zIndex: 2,
          }}
        />
      </Grow>

      <Box
        sx={{
          ...styles.background,
          // background: `url(${content.solution.background})`,
        }}
      />
    </Stack>
  );
};

export default Solution;
